(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["custom-klarna"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ohlala-klarna')) {
    customElements.define(
      'ohlala-klarna',
      class extends HTMLElement {
        connectedCallback() {
          this.section = this.closest('.shopify-section, dialog');
          this.section?.addEventListener('shopify:product:select', this.onProductSelect);
        }

        disconnectedCallback() {
          this.section?.removeEventListener('shopify:product:select', this.onProductSelect);
        }

        onProductSelect = (event) => {
          event.promise
            ?.then(({ detail }) => {
              if (!detail?.html) return;
              if (detail.newProduct) {
                this.dataset.productId = detail.newProduct.id;
              } else if (detail.productId && detail.productId !== this.dataset.productId) {
                return;
              }
              const fresh = detail.html.querySelector(`ohlala-klarna[data-block-id="${this.dataset.blockId}"]`);
              if (fresh) this.innerHTML = fresh.innerHTML;
            })
            .catch(() => {});
        };
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
